<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15Q7tPr/tc-custom/9781488018138.jpg?1702593802208" alt="This image is the cover for the book Falling for the Single Mom, Oaks Crossing"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Falling for the Single Mom, Oaks Crossing
      </h1>
      <p class="bookDescription body article font2">
        <b>Her Country Boy </b><br/><br/>Big-city veterinarian Heather Fitzgerald didn't plan on having kidsuntil her niece is orphaned one tragic night. Soon she's trading in her ambitious life for a small-town animal rescue. Heather didn't expect to fall for tiny Oaks Crossingor its most charming bachelor farmer. But when Josh Kinley saves her niece from a near-tragic accident, he becomes more than her hero. Josh never thought he'd fall in love againand most assuredly not with another city woman. But he can't resist the two adorable Fitzgerald females. Now if Josh can only convince Heather to put down roots and make a home with him
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mia Ross
      </h2>
      
      <p class="authorDescription body article">Mia Ross loves great stories. She enjoys reading about fascinating people, long-ago times, and exotic places. But only for a little while, because her reality is pretty sweet. A lifelong resident of Upstate New York, she's married and the proud mom of 2 amazing kids whose schedules keep her hopping. Busy as she is, she can't imagine trading her life for anyone else's--and she has a pretty good imagination. You can visit her online at www.miaross.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?13cbf7a3